const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export const getMaximumDateOfBirth = (today = new Date()) => ({
  year: today.getFullYear() - 21,
  month: today.getMonth() + 1,
  day: today.getDate(),
});

export const formatDateOfBirth = (year, month, day) =>
  `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

export const parseDateOfBirth = value => {
  const match = ISO_DATE_PATTERN.exec(value || '');
  return match
    ? { year: Number(match[1]), month: Number(match[2]), day: Number(match[3]) }
    : { year: '', month: '', day: '' };
};

export const getDaysInMonth = (year, month) =>
  year && month ? new Date(Date.UTC(year, month, 0)).getUTCDate() : 31;

/**
 * Validate a private date of birth and a minimum age using calendar dates.
 *
 * @param {string} value ISO date (YYYY-MM-DD)
 * @param {Date} today current date, injectable for tests
 * @returns {boolean} whether the date represents someone aged 21 or older
 */
export const isAtLeast21 = (value, today = new Date()) => {
  const match = ISO_DATE_PATTERN.exec(value || '');
  if (!match) return false;

  const [, yearString, monthString, dayString] = match;
  const year = Number(yearString);
  const month = Number(monthString);
  const day = Number(dayString);
  const date = new Date(Date.UTC(year, month - 1, day));
  const isRealDate =
    date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
  if (!isRealDate) return false;

  const todayUTC = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()));
  if (date > todayUTC) return false;

  const age =
    todayUTC.getUTCFullYear() -
    year -
    (todayUTC.getUTCMonth() < month - 1 ||
    (todayUTC.getUTCMonth() === month - 1 && todayUTC.getUTCDate() < day)
      ? 1
      : 0);
  return age >= 21;
};

/**
 * React Final Form validator for ResuelvePR's minimum age.
 *
 * @param {string} message validation message
 * @param {Date} today current date, injectable for tests
 * @returns {Function} field validator
 */
export const dateOfBirth21Validator = (message, today = new Date()) => value =>
  isAtLeast21(value, today) ? undefined : message;

export const assertValidDateOfBirth = (value, today = new Date()) => {
  if (!isAtLeast21(value, today)) {
    throw new Error('The date of birth must represent an age of at least 21 years.');
  }
  return value;
};
